import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminToken } from './api/adminClient';

// Wraps a class component page so it only renders for a logged-in admin.
// Doesn't verify the token's signature client-side (the backend does that
// on every request) — it just avoids flashing the admin UI with no token.
export default function AdminRoute({ children }) {
  if (!getAdminToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
